module.exports = "./assets/fonts/Nothing-You-Could-Do.woff";